import { IBiteAnswer } from '../types/biteQuestion';
import { generateFrontendId } from './frontendId';

export const createAnswer = (): IBiteAnswer => ({
  id: generateFrontendId(),
  text: '',
  is_correct: false,
  order: null,
});
